// API call debugging utility
class APIDebugger {
  constructor() {
    this.calls = new Map();
    this.enabled = process.env.NODE_ENV === 'development';
  }

  logCall(url, source = 'unknown') {
    if (!this.enabled) return;

    const key = url;
    const existing = this.calls.get(key) || { count: 0, sources: [], timestamps: [] };

    existing.count++;
    existing.sources.push(source);
    existing.timestamps.push(new Date().toISOString());

    this.calls.set(key, existing);

    console.group(`🌐 API Call: ${url}`);
    console.log(`📊 Call #${existing.count} from: ${source}`);
    console.log(`⏰ Time: ${existing.timestamps[existing.timestamps.length - 1]}`);

    if (existing.count > 1) {
      console.warn(`⚠️  Multiple calls detected! Previous calls from:`, existing.sources.slice(0, -1));
      console.log(`📈 All timestamps:`, existing.timestamps);
    }
    console.groupEnd();
  }

  getStats() {
    if (!this.enabled) return {};

    const stats = {};
    for (const [url, data] of this.calls.entries()) {
      stats[url] = {
        totalCalls: data.count,
        sources: [...new Set(data.sources)],
        firstCall: data.timestamps[0],
        lastCall: data.timestamps[data.timestamps.length - 1]
      };
    }
    return stats;
  }

  printStats() {
    if (!this.enabled) return;

    console.table(this.getStats());
  }

  reset() {
    this.calls.clear();
  }
}

export const apiDebugger = new APIDebugger();

// Add to window for debugging
if (typeof window !== 'undefined') {
  window.apiDebugger = apiDebugger;
}
